import { ServerAnnotationSettingsTags } from '../../features/auth/types/preferences.type';
import {
  PTags,
  QrsTags,
  ServerPTags,
  ServerQrsTags,
  WaveTag,
} from '../../features/wave/types/tag.type';

export const getServerTagsMock = (
  partialPTags?: Partial<Record<ServerPTags, boolean>>,
  partialQrsTags?: Partial<Record<ServerQrsTags, boolean>>,
): ServerAnnotationSettingsTags => ({
  P: {
    ...defaultServerPTags,
    ...partialPTags,
  },
  QRS: {
    ...defaultServerQrsTags,
    ...partialQrsTags,
  },
});

export const defaultServerPTags: Record<ServerPTags, boolean> = {
  sinus: true,
  pac: true,
  sve: true,
  atrial_paced: true,
  atrial_escape: true,
  retrograde: true,
};

export const defaultServerQrsTags: Record<ServerQrsTags, boolean> = {
  sinus: true,
  pac: true,
  pvc: true,
  pjc: true,
  sve: true,
  atrial_fibrillation: true,
  atrial_flutter: true,
  ventricular_paced: true,
  atrial_paced: true,
  junctional_escape: true,
  ventricular_escape: true,
  atrial_escape: true,
  noisy_rr: true,
};

export const defaultPTagsMock: PTags[] = [
  'SINUS',
  'PAC',
  'SVE',
  'ATRIAL_PACED',
  'ATRIAL_ESCAPE',
  'RETROGRADE',
];

export const defaultQrsTagsMock: QrsTags[] = [
  'SINUS',
  'PAC',
  'PVC',
  'PJC',
  'SVE',
  'ATRIAL_FIBRILLATION',
  'ATRIAL_FLUTTER',
  'VENTRICULAR_PACED',
  'ATRIAL_PACED',
  'JUNCTIONAL_ESCAPE',
  'VENTRICULAR_ESCAPE',
  'ATRIAL_ESCAPE',
  'NOISY_RR',
];

export const defaultWaveTagsMock: WaveTag = {
  P: defaultPTagsMock,
  QRS: defaultQrsTagsMock,
  calibration: ['CALIBRATION'],
  artifact: ['ARTIFACT'],
  noise: ['NOISE'],
};
